import React from 'react';
import moment from 'moment';

export default function GetfVDateFormate(obj, hastime, data) {
  if (hastime) return moment(hastime).format("M/D/YY hh:mm A");
  if (data) return moment(data).format("MM/DD/YYYY");
  if (obj) return moment(obj).format("M/D/YY");
}
